







import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import PageFetchHook from '@/components/mixins/PageFetchHook';
import store from '@/store';
import * as CvSectionSkillItemStoreEdit from '@/store/modules/cvSectionSkillItemEdit';
import EditContainer from '@/containers/cv-section-skill-item/edit.vue';

const { mapGetters } = createNamespacedHelpers(
  CvSectionSkillItemStoreEdit.namespace
);

const fetch = async params => {
  const { cv_id, cv_section_skill_id, id } = params;
  await store.dispatch(
    CvSectionSkillItemStoreEdit.GetCvSectionSkillItem.namespaced({
      params: { cv_id, cv_section_skill_id, id },
    })
  );
};

export default Vue.extend({
  components: {
    EditContainer,
  },
  mixins: [PageLeftHook, PageFetchHook(fetch)],
  data() {
    return {
      storeList: [CvSectionSkillItemStoreEdit],
    };
  },
  computed: {
    ...mapGetters(['cvSectionSkillItem']),
  },
});
